export default "__VITE_ASSET__UbjSSJ5U__"